

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M16.1.25c3.91 0 5.65 1.74 5.65 5.65v4.2c0 3.91-1.74 5.65-5.65 5.65h-.35v.35c0 3.91-1.74 5.65-5.65 5.65H5.9c-3.91 0-5.65-1.74-5.65-5.65v-4.2c0-3.91 1.74-5.65 5.65-5.65h.35V5.9C6.25 1.99 7.99.25 11.9.25h4.2ZM5.9 7.75c-3.1 0-4.15 1.05-4.15 4.15v4.2c0 3.1 1.05 4.15 4.15 4.15h4.2c3.1 0 4.15-1.05 4.15-4.15v-4.2c0-3.1-1.05-4.15-4.15-4.15H5.9Zm9.85 4.15v2.35h.35c3.1 0 4.15-1.05 4.15-4.15V5.9c0-3.1-1.05-4.15-4.15-4.15h-4.2c-3.1 0-4.15 1.05-4.15 4.15v.35h2.35c3.91 0 5.65 1.74 5.65 5.65Z"}, []), "\n"]);
};

        